import PropTypes from 'prop-types';
import React from 'react';

// context
import ErrorContext from '../../context/ErrorContext';

// components
import FailureMessage from '../FailureMessage';

// utils
import translationFromBody from '../../../utils/getTranslationFromBody';
import logError from '../../../utils/logError';

class ErrorBoundary extends React.PureComponent {
  componentDidCatch({ message: errorMessage, stack }, { componentStack }) {
    const { setError } = this.context;
    const { handleError } = this.props;

    const error = JSON.stringify({ errorMessage, stack, componentStack });
    setError(error);
    handleError(error);
  }

  render() {
    const { children, onErrorRender: ErrorMessage } = this.props;
    const { isError } = this.context;
    const errorMessageProps = {
      title: translationFromBody.errorMessageTitle,
      message: translationFromBody.errorMessageDetails,
    };

    return isError ? <ErrorMessage {...errorMessageProps} /> : children;
  }
}

ErrorBoundary.contextType = ErrorContext;

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  handleError: PropTypes.func,
  onErrorRender: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  handleError: logError,
  onErrorRender: FailureMessage,
};

export default ErrorBoundary;
